import html2pdf from 'html2pdf.js';

/**
 * Export a specific element to PDF
 * @param {string} elementId - The ID of the element to export
 * @param {string} filename - The name of the PDF file (without .pdf extension)
 * @param {Object} options - Additional options for the PDF
 */
export const exportToPDF = async (elementId, filename, options = {}) => {
  const element = document.getElementById(elementId);
  if (!element) {
    return false;
  }

  const defaultOptions = {
    margin: [0.5, 0.5, 0.5, 0.5],
    filename: `${filename}.pdf`,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { 
      scale: 2,
      useCORS: true,
      logging: false 
    },
    jsPDF: { 
      unit: 'in', 
      format: 'letter', 
      orientation: 'portrait' 
    },
    pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
  };

  const mergedOptions = { ...defaultOptions, ...options };

  try {
    await html2pdf().set(mergedOptions).from(element).save();
    return true;
  } catch (_e) {
    return false;
  }
};

/**
 * Export guide content to PDF with proper styling
 * @param {string} elementId - The ID of the content element to export
 * @param {string} filename - The name of the PDF file
 * @param {string} title - Title to show in PDF header
 */
export const exportGuideToPDF = async (elementId, filename, title) => {
  const element = document.getElementById(elementId);
  if (!element) {
    return false;
  }

  // Clone element for PDF generation to avoid modifying the DOM
  const clonedElement = element.cloneNode(true);
  
  // Create a wrapper with proper styling
  const wrapper = document.createElement('div');
  wrapper.style.cssText = `
    padding: 20px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    background: white;
    color: #1e293b;
  `;
  wrapper.appendChild(clonedElement);

  // Temporarily add to DOM for rendering
  wrapper.style.position = 'absolute';
  wrapper.style.left = '-9999px';
  document.body.appendChild(wrapper);

  const options = {
    margin: [0.75, 0.75, 0.75, 0.75],
    filename: `${filename}.pdf`,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { 
      scale: 2,
      useCORS: true,
      logging: false,
      backgroundColor: '#ffffff'
    },
    jsPDF: { 
      unit: 'in', 
      format: 'letter', 
      orientation: 'portrait' 
    },
    pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
  };

  try {
    await html2pdf().set(options).from(wrapper).save();
    document.body.removeChild(wrapper);
    return true;
  } catch (_e) {
    document.body.removeChild(wrapper);
    return false;
  }
};
